var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AuthService } from './../modules/auth/auth.service';
import { Component } from '@angular/core';
var TopNavComponent = (function () {
    function TopNavComponent(auth) {
        this.auth = auth;
    }
    TopNavComponent.prototype.minimalize = function () {
        $('body').toggleClass('mini-navbar');
        if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
            // Hide menu in order to smoothly turn on when maximize menu
            $('#side-menu').hide();
            // For smoothly turn on menu
            setTimeout(function () {
                $('#side-menu').fadeIn(400);
            }, 200);
        }
        else {
            // Remove all inline style from jquery fadeIn function to reset menu state
            $('#side-menu').removeAttr('style');
        }
    };
    TopNavComponent.prototype.logout = function () {
        this.auth.logout();
    };
    TopNavComponent = __decorate([
        Component({
            selector: 'cx-topnav',
            templateUrl: './common/topnavbar.component.html',
        }),
        __metadata("design:paramtypes", [AuthService])
    ], TopNavComponent);
    return TopNavComponent;
}());
export { TopNavComponent };
//# sourceMappingURL=topnav.component.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/components/topnav.component.js
// module id = 538
// module chunks = 0